export default __webpack_public_path__ + "static/media/shopify.c188576e.svg";